import React from 'react';

//CheckCircleFill2Icon
import { ReactComponent as SuccessIcon } from 'assets/icons/check-circle-fill-2.svg';
//exclamation-triangle-fill
import { ReactComponent as WarningIcon } from 'assets/icons/exclamation-triangle-fill.svg';
//exclamation-circle-fill.svg
import { ReactComponent as InfoIcon } from 'assets/icons/exclamation-circle-fill.svg';

interface props {
    type?: string;
    icon?: string | React.ReactNode;
    showIcon?: boolean;
}

export const DialogIcon = ({ type = 'success', icon, showIcon = true }: props) => {
    if (!showIcon) {
        return <></>;
    }
    if (icon) {
        if (typeof icon === 'string') {
            return <img src={icon} />;
        }
        return <>{icon}</>;
    }
    if (type == 'success') {
        return <SuccessIcon />;
    }
    if (type == 'info') {
        return <InfoIcon />;
    }
    if (type == 'warning') {
        return <WarningIcon />;
    }

    return <></>;
};
